import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6 16V13L22 13V11L6 11L6 8L2 12L6 16Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SmallLongLeft"
);
